import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome' 
import { faMapMarkerAlt, faPhone, faClock, faFlag } from '@fortawesome/fontawesome-free-solid'

export default class Contact extends Component {

    handleButton = (e) => {
        const value = e.target.value.replace(/[^A-zÀ-ÿ0-9_ :(),]+/, '')
        this.props.handleIsAnnexeDisplay(value)
    }

    render() {
        const doctors = this.props.doctors
        const englishSelected = this.props.englishSelected

        return (
            <main id="main">
                <div id="banner" className="map">
                    <iframe title="myFrame" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2586.349552688233!2d6.138648648410028!3d49.59115731129945!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479548c05a1511fd%3A0x8804fe23a2ed4258!2s88%20Rue%20du%20Cimeti%C3%A8re%2C%201338%20Luxembourg!5e0!3m2!1sfr!2sfr!4v1583486580290!5m2!1sfr!2sfr"></iframe>
                </div>
                <div className="street-view-container content">
                    <h1>{englishSelected ? 'Contact & access Centre Médical Bonnevoie' : 'Contact & accès Centre Médical Bonnevoie' }</h1>
                    <div className="row">
                        <div className="col-xs-12 col-md-6 contact-item">
                            <FontAwesomeIcon className="fa" size="3x" icon={faMapMarkerAlt} />
                            <p>
                                88, rue du Cimetière <br/>
                                L-1338 Luxembourg
                                <br/>
                                <br/>
                                Bus: 2, 3 & 29
                                <br/>
                                <br/>
                                {englishSelected ? 'Tram T1 exit: lycée de Bonnevoie' :
                                    'Tram T1 sortie: lycée de Bonnevoie' }

                                <br/>
                                <br/>
                            </p>

                        </div>
                        <div className="col-xs-12 col-md-6 contact-item phone-item">
                            <FontAwesomeIcon className="fa" rotation={90} size="3x" icon={faPhone} />

                                <p>
                                    <strong>Dr Barret-de-Gassart: </strong>{doctors['2-barretdegassart']['phone']}<br/>
                                    <strong>Dr Weber: </strong>{doctors['3-weber']['phone']}<br/>
                                    <strong>Dr Krombach: </strong>{doctors['4-krombach']['phone']}<br/>
                                    <strong>Dr Du Reau: </strong>{doctors['5-dureau']['phone']}<br/>
                                    <strong>Dr Stricker: </strong>{doctors['9-nathanaelStricker']['phone']}<br/>
                                    {/*TODO Add here new Doctors*/}
                                    <strong>Fax:</strong> 26 12 30 31 <br/>
                                    <strong>Mail: <a href="mailto:info@centre-medical-bonnevoie.lu">info@centre-medical-bonnevoie.lu</a></strong>
                                </p>


                        </div>
                        <div className="col-xs-12 col-md-6 contact-item timetable">
                            <FontAwesomeIcon className="fa" size="3x" icon={faClock} />
                            <table>
                                <thead>

                                </thead>
                                <tbody>
                                <tr>
                                    <th>
                                       {englishSelected ? 'Monday' : 'Lundi'}
                                    </th>
                                    <td> 8h00 - 12h00</td>
                                    <td> 14h00 - 18h00</td>
                                </tr>
                                <tr>
                                    <th>
                                        {englishSelected ? 'Tuesday' : 'Mardi'}
                                    </th>
                                    <td> 8h00 - 12h00</td>
                                    <td> 14h00 - 18h00</td>
                                </tr>
                                <tr>
                                    <th>
                                        {englishSelected ? 'Wednesday' : 'Mercredi'}
                                    </th>
                                    <td> 8h00 - 12h00</td>

                                </tr>
                                <tr>
                                    <th>
                                        {englishSelected ? 'Thursday' : 'Jeudi'}
                                    </th>
                                    <td> 8h00 - 12h00</td>
                                    <td> 14h00 - 18h00</td>
                                </tr>
                                <tr>
                                    <th>
                                        {englishSelected ? 'Friday' : 'Vendredi'}
                                    </th>
                                    <td> 8h00 - 12h00</td>
                                    <td> 14h00 - 18h00</td>
                                </tr>
                                </tbody>
                                
                            </table>
                        </div>
                        <div className="col-xs-12 col-md-6 contact-item language">
                            <FontAwesomeIcon className="fa" size="3x" icon={faFlag} />
                            <div>
                                <p>
                                    {englishSelected ? 'We speak : ' : 'Nous parlons : '}
                                </p>
                                <ul>
                                    <li>{englishSelected ? 'French' : 'Français'}</li>
                                    <li>{englishSelected ? 'English' : 'Anglais'}</li>

                                        <li>{englishSelected ? 'Luxembourgish' : 'Luxembourgeois'}</li>

                                    <li>{englishSelected ? 'German' : 'Allemand'}</li>


                                </ul>
                            </div>
                        </div>
                    </div>

                </div>

            </main>
        )
    }
}
